import { Injectable } from '@angular/core';
import { HttpClientWrapper } from '../httpclientwrapper';
import { Observable } from 'rxjs';
import { ResultsWithOutPagination } from '@apply4u/models/search/results-with-out-pagination';
import { IsNotNull, IsNotZero, IsTrue } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { UserSaveSearches } from '@apply4u/models/user-save-search/user-save-search';
import { UserAutoSaveSearch } from '@apply4u/models/user-save-search/user-auto-save-search';
import { UserSaveSearchStatistics } from '@apply4u/models/user-save-search/user-auto-search-statistics';

@Injectable({
    providedIn: 'root'
})
export class UserSaveSearchService {

    constructor(private http: HttpClientWrapper) { }

    GetUserSaveSearch(userId: number, isJobSearch: boolean = null, isCvSearch: boolean = null, emailFrequencyId: number = null, savedSearchTypeId: number = null,
        isActive: boolean = null, isDefault: boolean = null, pageNumber: number = null, pageSize: number = null): Observable<ResultsWithOutPagination<UserSaveSearches>> {

        let requesPramas = "?";

        if (IsTrue(isJobSearch)) {
            requesPramas += 'isJobSearch=' + isJobSearch;
        }

        if (IsTrue(isCvSearch)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isCvSearch=" + isCvSearch;
        }

        if (IsNotZero(emailFrequencyId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "emailFrequencyId=" + emailFrequencyId;
        }

        if (IsNotZero(savedSearchTypeId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "savedSearchTypeId=" + savedSearchTypeId;
        }

        if (IsTrue(isActive)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isActive=" + isActive;
        }

        if (IsTrue(isDefault)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isDefault=" + isDefault;
        }

        if (IsNotZero(pageNumber)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageNumber=" + pageNumber;
        }

        if (IsNotZero(pageSize)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageSize=" + pageSize;
        }

        return this.http.GetAsync<ResultsWithOutPagination<UserSaveSearches>>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/all${requesPramas}`);
    }

    GetUserSaveSearchById(userId: number, searchId: number): Observable<UserAutoSaveSearch> {
        return this.http.GetAsync<UserAutoSaveSearch>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/${searchId}`);
    }

    UpdateUserSaveSearch(id: number, userId: number, userSearch: UserAutoSaveSearch): Observable<any> {
        return this.http.PutAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/${id}`, userSearch);
    }

    SaveUserSearches(userId: number, userSearch: UserAutoSaveSearch): Observable<any> {
        if (IsNotNull(userSearch)) {
            userSearch.SavedSearchTypeId = 2; //SaveSearchTypeId = 2 Manual Created by User itself
        }
        return this.http.PostAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches`, userSearch);
    }

    DeleteUserSearch(userId: number, searchId: number): Observable<any> {
        return this.http.DeleteAsync(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches?id=${searchId}`);
    }

    GetUserSearchesLimit(userId: number, dashboardTypeId: number): Observable<UserSaveSearchStatistics> {       
        return this.http.GetAsync<UserSaveSearchStatistics>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/statistics/${dashboardTypeId}?stamp=${(new Date()).getTime()}`);
    }

    DeactivateUserOldSearches(userId: number, dashboardTypeId: number): Observable<any> {
        return this.http.GetAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/deactivate/${dashboardTypeId}`);
    }

    IsUserSearchExists(userId: number,saveSearches: UserAutoSaveSearch): Observable<boolean> {        
        return this.http.PostAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/isExists`, saveSearches);
    }

    UpdateIsActiveFlag(userId: number,saveSearchId: number, isActive:boolean): Observable<any> {
        return this.http.PostAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserSearches/changeActivationStatus?savedSearchId=${saveSearchId}&isActive=${isActive}`, null);
    }   

    IsAddOnEnabled(userId: number, addOnId: number): Observable<any> {
        return this.http.GetAsync<any>(this.http.TransmitterApiBaseUrl + `api/User/${userId}/UserPackage/addon?addOnId=${addOnId}`);
    }  

}
